const mockUser = {
  profile: {
    name: 'Alex Ramirez',
    age: 31,
    occupation: 'Marketing Manager',
    location: 'Austin, TX',
    income: 86000,
    maritalStatus: 'Single',
    lifestyle: 'Urban renter, student loan debt, moderate spender, investing in Roth IRA and a brokerage account',
  },
  paystubs: [
    {
      date: '2025-05-10',
      gross: 3307.69,
      deductions: 700.00,
      net: 2607.69,
      employer: 'NextGen Media Co.'
    },
    {
      date: '2025-05-24',
      gross: 3307.69,
      deductions: 695.34,
      net: 2612.35,
      employer: 'NextGen Media Co.'
    }
  ],
  accounts: [
    {
      id: 'acc-checking',
      type: 'checking',
      institution: 'Chase',
      balance: 4250.00,
      name: 'Chase Total Checking'
    },
    {
      id: 'acc-savings',
      type: 'savings',
      institution: 'Ally',
      balance: 6100.00,
      name: 'High-Yield Savings'
    },
    {
      id: 'acc-brokerage',
      type: 'brokerage',
      institution: 'Fidelity',
      balance: 12400.00,
      name: 'Fidelity Brokerage'
    },
    {
      id: 'acc-retirement',
      type: 'retirement',
      institution: 'Fidelity',
      balance: 9700.00,
      name: 'Roth IRA'
    },
    {
      id: 'acc-crypto',
      type: 'crypto',
      institution: 'Coinbase',
      balance: 1200.00,
      name: 'Crypto Portfolio'
    }
  ],
  liabilities: [
    {
      type: 'credit_card',
      institution: 'Chase',
      balance: 2850.00,
      limit: 6000.00,
      name: 'Chase Sapphire',
      id: 'liab-cc',
      monthly_payment: 120.00,
      interest_rate: 18.99,
      minimum_payment: 57.00
    },
    {
      type: 'student_loan',
      institution: 'Navient',
      balance: 18000.00,
      monthly_payment: 310.00,
      interest_rate: 5.6,
      id: 'liab-student',
      name: 'Student Loan'
    },
    {
      type: 'auto_loan',
      institution: 'Capital One Auto',
      balance: 8400.00,
      monthly_payment: 289.00,
      interest_rate: 3.9,
      id: 'liab-auto',
      name: 'Auto Loan'
    }
  ],
  monthly_spending: {
    rent: 1750.00,
    groceries: 450.00,
    dining_out: 380.00,
    transportation: 120.00,
    auto_loan: 289.00,
    student_loan: 310.00,
    utilities: 140.00,
    subscriptions: 95.00,
    entertainment: 200.00,
    travel: 300.00,
    savings: 600.00,
    investments: 500.00
  },
  // New: Notifications data
  notifications: [
    {
      id: 'notif-1',
      type: 'bill_increase',
      title: 'Bill increase',
      message: 'Your cable bill increased by $16. You were charged $111 this month vs. $95 last month.',
      date: '2025-06-28',
      read: false,
      priority: 'medium',
      category: 'Bills'
    },
    {
      id: 'notif-2',
      type: 'payment_due',
      title: 'Credit Card Payment Due',
      message: 'Your Chase Sapphire payment of $700 is due in 3 days.',
      date: '2025-06-25',
      read: false,
      priority: 'high',
      category: 'Payments',
      account_id: 'liab-cc'
    },
    {
      id: 'notif-3',
      type: 'deposit_received',
      title: 'Direct Deposit Received',
      message: 'Your paycheck from NextGen Media Co. was deposited.',
      date: '2025-06-24',
      read: true,
      priority: 'low',
      category: 'Income',
      account_id: 'acc-checking'
    },
    {
      id: 'notif-4',
      type: 'investment_alert',
      title: 'Investment Alert',
      message: 'Fidelity Brokerage: Your portfolio is up 4% this month.',
      date: '2025-06-20',
      read: true,
      priority: 'medium',
      category: 'Investments',
      account_id: 'acc-brokerage'
    },
    {
      id: 'notif-5',
      type: 'subscription_renewal',
      title: 'Subscription Renewal',
      message: 'Your Netflix subscription renewed for $15.99.',
      date: '2025-06-15',
      read: true,
      priority: 'low',
      category: 'Subscriptions'
    }
  ],
  // New: Net Worth History data
  netWorthHistory: [
    { date: '2025-01', value: 3150, assets: 32400, liabilities: 29250 },
    { date: '2025-02', value: 3350, assets: 32550, liabilities: 29200 },
    { date: '2025-03', value: 3550, assets: 32700, liabilities: 29150 },
    { date: '2025-04', value: 3750, assets: 32850, liabilities: 29100 },
    { date: '2025-05', value: 3950, assets: 33000, liabilities: 29050 },
    { date: '2025-06', value: 4400, assets: 33650, liabilities: 29250 } // Current month
  ],
  // New: AI Chat history
  aiChatHistory: [
    {
      id: 'chat-1',
      type: 'ai',
      content: "Hi! I'm your Zecher AI assistant. How can I help you with your finances today?",
      timestamp: '2025-06-20T10:00:00Z'
    }
  ],
  // New: Insights data
  insights: [
    {
      id: 'insight-1',
      type: 'spending_alert',
      title: 'Dining Out Spending Up',
      message: 'You\'ve spent 20% more on dining out this month compared to your budget.',
      category: 'dining_out',
      severity: 'warning',
      actionable: true,
      action: 'Consider meal planning to reduce restaurant visits',
      date: '2025-06-25',
      read: false
    },
    {
      id: 'insight-2',
      type: 'savings_opportunity',
      title: 'Great Savings Month!',
      message: 'You\'re on track to save $50 more than budgeted this month.',
      category: 'savings',
      severity: 'positive',
      actionable: true,
      action: 'Consider investing the extra savings',
      date: '2025-06-20',
      read: false
    },
    {
      id: 'insight-3',
      type: 'bill_optimization',
      title: 'Subscription Review',
      message: 'You have 6 active subscriptions totaling $95/month. Consider reviewing unused ones.',
      category: 'subscriptions',
      severity: 'info',
      actionable: true,
      action: 'Review and cancel unused subscriptions',
      date: '2025-06-15',
      read: true
    }
  ],
  // New: Zecher Score factors
  zecherScore: {
    current: 73,
    history: [
      { date: '2025-01', score: 68 },
      { date: '2025-02', score: 70 },
      { date: '2025-03', score: 71 },
      { date: '2025-04', score: 72 },
      { date: '2025-05', score: 73 },
      { date: '2025-06', score: 73 }
    ],
    factors: {
      debt_to_income: { score: 75, weight: 0.25, description: 'Debt payments are 25% of income' },
      savings_rate: { score: 80, weight: 0.20, description: 'Saving 15% of income monthly' },
      payment_history: { score: 90, weight: 0.20, description: 'No missed payments' },
      credit_utilization: { score: 60, weight: 0.15, description: 'Credit card 48% utilized' },
      emergency_fund: { score: 65, weight: 0.10, description: '3.5 months of expenses saved' },
      investment_diversity: { score: 70, weight: 0.10, description: 'Good mix of retirement and brokerage' }
    }
  },
  protection: [
    {
      type: 'whole_life',
      provider: 'Northwestern Mutual',
      coverage: 250000,
      premium: 180,
      status: 'active',
      policy_number: 'WL-1234567'
    },
    {
      type: 'term_life',
      provider: 'State Farm',
      coverage: 500000,
      premium: 45,
      status: 'active',
      policy_number: 'TL-9876543'
    },
    {
      type: 'mortgage',
      provider: 'Quicken Loans',
      coverage: 275000,
      premium: 120,
      status: 'active',
      policy_number: 'MORT-5558888'
    }
  ],
  // --- Fact Finder Section ---
  factFinder: {
    personal: {
      fullName: 'Alex Ramirez',
      dob: '1994-08-15',
      address: '1200 Barton Springs Rd, Austin, TX 78704',
      maritalStatus: 'Single',
      partner: null,
      pets: [{ type: 'dog', breed: 'goldendoodle', name: 'Sunny' }],
      notes: 'Urban renter, moderate spender, investing in Roth IRA and brokerage.'
    },
    employment: {
      employer: 'NextGen Media Co.',
      title: 'Marketing Manager',
      startDate: '2023-01-15',
      payStructure: 'Base + Bonus',
      baseSalary: 86000,
      bonus: 5000,
      payFrequency: 'Bi-weekly',
      stockPlan: {
        type: 'ESPP',
        details: 'Employee stock purchase at 5% discount, 2x/year',
        estimatedValue: 2500
      },
      benefits: {
        health: 'Active',
        disability: 'Long Term Disability (1x salary)',
        life: 'Group Life (1x salary)',
        dental: 'Active',
        vision: 'Active',
        retirement: '401k with 3% match',
        notes: 'No dependents, no personal life insurance.'
      }
    },
    banking: {
      accounts: [
        { type: 'checking', institution: 'Chase', balance: 4250 },
        { type: 'savings', institution: 'Ally', balance: 6100 },
        { type: 'brokerage', institution: 'Fidelity', balance: 12400 },
        { type: 'retirement', institution: 'Fidelity', balance: 9700 },
        { type: 'crypto', institution: 'Coinbase', balance: 1200 }
      ],
      transfers: [
        { from: 'checking', to: 'savings', amount: 600, frequency: 'monthly' },
        { from: 'checking', to: 'brokerage', amount: 500, frequency: 'monthly' }
      ]
    },
    liabilities: [
      { type: 'credit_card', institution: 'Chase', balance: 2850, limit: 6000, monthly_payment: 120 },
      { type: 'student_loan', institution: 'Navient', balance: 18000, monthly_payment: 310, interest_rate: 5.6 },
      { type: 'auto_loan', institution: 'Capital One Auto', balance: 8400, monthly_payment: 289, interest_rate: 3.9 }
    ],
    insurance: {
      auto: { provider: 'USAA', premium: 95, liability: '30k/60k', deductible: 500 },
      renters: { provider: 'Lemonade', premium: 18, liability: 100000, deductible: 250 },
      life: [
        { type: 'whole_life', provider: 'Northwestern Mutual', coverage: 250000, premium: 180, status: 'active' },
        { type: 'term_life', provider: 'State Farm', coverage: 500000, premium: 45, status: 'active' }
      ],
      disability: { group: '1x salary', provider: 'NextGen Media Co.' }
    },
    estate: {
      will: false,
      trust: false,
      healthCareProxy: true,
      notes: 'No dependents, no personal life insurance. Health care proxy in place.'
    },
    costOfLiving: {
      rent: 1750,
      averageMonthlyBills: 1200,
      totalMonthly: 2950
    },
    goals: [
      'Increase savings rate to 25%',
      'Pay off credit card monthly',
      'Rollover old 401k',
      'Buy a home in 2 years'
    ],
    notes: 'Fact finder auto-generated for demo. Some values are estimated.'
  },
  // --- Transactions: 6 months of realistic data ---
  transactions: [
    // January 2025
    { id: 'jan1', date: '2025-01-03', amount: -1750, category: 'Rent', account_id: 'acc-checking', merchant: 'Austin Apartments', type: 'debit' },
    { id: 'jan2', date: '2025-01-05', amount: -289, category: 'Auto Loan', account_id: 'acc-checking', merchant: 'Capital One Auto', type: 'debit' },
    { id: 'jan3', date: '2025-01-07', amount: -120, category: 'Auto Insurance', account_id: 'acc-checking', merchant: 'USAA', type: 'debit' },
    { id: 'jan4', date: '2025-01-09', amount: -140, category: 'Utilities', account_id: 'acc-checking', merchant: 'Austin Energy', type: 'debit' },
    { id: 'jan5', date: '2025-01-10', amount: -60, category: 'Phone', account_id: 'acc-checking', merchant: 'AT&T', type: 'debit' },
    { id: 'jan6', date: '2025-01-12', amount: -55, category: 'Internet', account_id: 'acc-checking', merchant: 'Spectrum', type: 'debit' },
    { id: 'jan7', date: '2025-01-10', amount: -15.99, category: 'Subscriptions', account_id: 'liab-cc', merchant: 'Netflix', type: 'debit' },
    { id: 'jan8', date: '2025-01-10', amount: -14.99, category: 'Subscriptions', account_id: 'liab-cc', merchant: 'HBO Max', type: 'debit' },
    { id: 'jan9', date: '2025-01-10', amount: -12.99, category: 'Subscriptions', account_id: 'liab-cc', merchant: 'Hulu', type: 'debit' },
    { id: 'jan10', date: '2025-01-10', amount: -7.99, category: 'Subscriptions', account_id: 'liab-cc', merchant: 'Disney+', type: 'debit' },
    { id: 'jan11', date: '2025-01-13', amount: -9.99, category: 'Subscriptions', account_id: 'liab-cc', merchant: 'Spotify', type: 'debit' },
    { id: 'jan12', date: '2025-01-13', amount: -10.00, category: 'Subscriptions', account_id: 'liab-cc', merchant: "Gold's Gym", type: 'debit' },
    { id: 'jan13', date: '2025-01-10', amount: 2607.69, category: 'Salary', account_id: 'acc-checking', merchant: 'NextGen Media Co.', type: 'credit' },
    { id: 'jan14', date: '2025-01-24', amount: 2612.35, category: 'Salary', account_id: 'acc-checking', merchant: 'NextGen Media Co.', type: 'credit' },
    { id: 'jan15', date: '2025-01-25', amount: -600, category: 'Savings', account_id: 'acc-checking', merchant: 'Transfer to Ally', type: 'debit' },
    { id: 'jan16', date: '2025-01-26', amount: -500, category: 'Investments', account_id: 'acc-checking', merchant: 'Transfer to Fidelity', type: 'debit' },
    { id: 'jan17', date: '2025-01-07', amount: -92.10, category: 'Groceries', account_id: 'acc-checking', merchant: 'H-E-B', type: 'debit' },
    { id: 'jan18', date: '2025-01-14', amount: -68.45, category: 'Groceries', account_id: 'acc-checking', merchant: "Trader Joe's", type: 'debit' },
    { id: 'jan19', date: '2025-01-21', amount: -101.32, category: 'Groceries', account_id: 'acc-checking', merchant: 'Whole Foods', type: 'debit' },
    { id: 'jan20', date: '2025-01-28', amount: -57.80, category: 'Groceries', account_id: 'acc-checking', merchant: 'Randalls', type: 'debit' },
    { id: 'jan21', date: '2025-01-04', amount: -13.50, category: 'Dining Out', account_id: 'liab-cc', merchant: 'Starbucks', type: 'debit' },
    { id: 'jan22', date: '2025-01-08', amount: -19.75, category: 'Dining Out', account_id: 'liab-cc', merchant: 'Chipotle', type: 'debit' },
    { id: 'jan23', date: '2025-01-11', amount: -8.25, category: 'Dining Out', account_id: 'liab-cc', merchant: "McDonald's", type: 'debit' },
    { id: 'jan24', date: '2025-01-15', amount: -29.00, category: 'Dining Out', account_id: 'liab-cc', merchant: 'Uchi Sushi', type: 'debit' },
    { id: 'jan25', date: '2025-01-18', amount: -6.50, category: 'Dining Out', account_id: 'liab-cc', merchant: "Dunkin'", type: 'debit' },
    { id: 'jan26', date: '2025-01-22', amount: -22.00, category: 'Dining Out', account_id: 'liab-cc', merchant: "Torchy's Tacos", type: 'debit' },
    { id: 'jan27', date: '2025-01-25', amount: -14.00, category: 'Dining Out', account_id: 'liab-cc', merchant: "P. Terry's", type: 'debit' },
    { id: 'jan28', date: '2025-01-29', amount: -39.60, category: 'Dining Out', account_id: 'liab-cc', merchant: 'Home Slice Pizza', type: 'debit' },
    { id: 'jan29', date: '2025-01-06', amount: -36.00, category: 'Gas', account_id: 'acc-checking', merchant: 'Shell', type: 'debit' },
    { id: 'jan30', date: '2025-01-20', amount: -41.50, category: 'Gas', account_id: 'acc-checking', merchant: 'Exxon', type: 'debit' },
    { id: 'jan31', date: '2025-01-12', amount: -19.99, category: 'Shopping', account_id: 'liab-cc', merchant: 'Amazon', type: 'debit' },
    { id: 'jan32', date: '2025-01-23', amount: -49.99, category: 'Shopping', account_id: 'liab-cc', merchant: 'Amazon', type: 'debit' },
    { id: 'jan33', date: '2025-01-14', amount: -18.00, category: 'Transfer', account_id: 'acc-checking', merchant: 'Venmo', type: 'debit' },
    { id: 'jan34', date: '2025-01-27', amount: 40.00, category: 'Transfer', account_id: 'acc-checking', merchant: 'Venmo', type: 'credit' },
    // February 2025 (updated, detailed)
    { id: 'feb1', date: '2025-02-03', amount: -1750, category: 'Rent', account_id: 'acc-checking', merchant: 'Austin Apartments', type: 'debit' },
    { id: 'feb2', date: '2025-02-05', amount: -289, category: 'Auto Loan', account_id: 'acc-checking', merchant: 'Capital One Auto', type: 'debit' },
    { id: 'feb3', date: '2025-02-07', amount: -120, category: 'Auto Insurance', account_id: 'acc-checking', merchant: 'USAA', type: 'debit' },
    { id: 'feb4', date: '2025-02-09', amount: -140, category: 'Utilities', account_id: 'acc-checking', merchant: 'Austin Energy', type: 'debit' },
    { id: 'feb5', date: '2025-02-10', amount: -60, category: 'Phone', account_id: 'acc-checking', merchant: 'AT&T', type: 'debit' },
    { id: 'feb6', date: '2025-02-12', amount: -55, category: 'Internet', account_id: 'acc-checking', merchant: 'Spectrum', type: 'debit' },
    { id: 'feb7', date: '2025-02-10', amount: -15.99, category: 'Subscriptions', account_id: 'liab-cc', merchant: 'Netflix', type: 'debit' },
    { id: 'feb8', date: '2025-02-10', amount: -14.99, category: 'Subscriptions', account_id: 'liab-cc', merchant: 'HBO Max', type: 'debit' },
    { id: 'feb9', date: '2025-02-10', amount: -12.99, category: 'Subscriptions', account_id: 'liab-cc', merchant: 'Hulu', type: 'debit' },
    { id: 'feb10', date: '2025-02-10', amount: -7.99, category: 'Subscriptions', account_id: 'liab-cc', merchant: 'Disney+', type: 'debit' },
    { id: 'feb11', date: '2025-02-13', amount: -9.99, category: 'Subscriptions', account_id: 'liab-cc', merchant: 'Spotify', type: 'debit' },
    { id: 'feb12', date: '2025-02-13', amount: -10.00, category: 'Subscriptions', account_id: 'liab-cc', merchant: "Gold's Gym", type: 'debit' },
    { id: 'feb13', date: '2025-02-10', amount: 2607.69, category: 'Salary', account_id: 'acc-checking', merchant: 'NextGen Media Co.', type: 'credit' },
    { id: 'feb14', date: '2025-02-24', amount: 2612.35, category: 'Salary', account_id: 'acc-checking', merchant: 'NextGen Media Co.', type: 'credit' },
    { id: 'feb15', date: '2025-02-25', amount: -600, category: 'Savings', account_id: 'acc-checking', merchant: 'Transfer to Ally', type: 'debit' },
    { id: 'feb16', date: '2025-02-26', amount: -500, category: 'Investments', account_id: 'acc-checking', merchant: 'Transfer to Fidelity', type: 'debit' },
    { id: 'feb17', date: '2025-02-07', amount: -88.20, category: 'Groceries', account_id: 'acc-checking', merchant: 'H-E-B', type: 'debit' },
    { id: 'feb18', date: '2025-02-14', amount: -72.10, category: 'Groceries', account_id: 'acc-checking', merchant: "Trader Joe's", type: 'debit' },
    { id: 'feb19', date: '2025-02-21', amount: -109.45, category: 'Groceries', account_id: 'acc-checking', merchant: 'Whole Foods', type: 'debit' },
    { id: 'feb20', date: '2025-02-28', amount: -61.30, category: 'Groceries', account_id: 'acc-checking', merchant: 'Randalls', type: 'debit' },
    { id: 'feb21', date: '2025-02-04', amount: -14.25, category: 'Dining Out', account_id: 'liab-cc', merchant: 'Starbucks', type: 'debit' },
    { id: 'feb22', date: '2025-02-08', amount: -21.50, category: 'Dining Out', account_id: 'liab-cc', merchant: 'Chipotle', type: 'debit' },
    { id: 'feb23', date: '2025-02-11', amount: -9.75, category: 'Dining Out', account_id: 'liab-cc', merchant: "McDonald's", type: 'debit' },
    { id: 'feb24', date: '2025-02-15', amount: -31.00, category: 'Dining Out', account_id: 'liab-cc', merchant: 'Uchi Sushi', type: 'debit' },
    { id: 'feb25', date: '2025-02-18', amount: -7.25, category: 'Dining Out', account_id: 'liab-cc', merchant: "Dunkin'", type: 'debit' },
    { id: 'feb26', date: '2025-02-22', amount: -23.50, category: 'Dining Out', account_id: 'liab-cc', merchant: "Torchy's Tacos", type: 'debit' },
    { id: 'feb27', date: '2025-02-25', amount: -15.00, category: 'Dining Out', account_id: 'liab-cc', merchant: "P. Terry's", type: 'debit' },
    { id: 'feb28', date: '2025-02-27', amount: -41.80, category: 'Dining Out', account_id: 'liab-cc', merchant: 'Home Slice Pizza', type: 'debit' },
    { id: 'feb29', date: '2025-02-06', amount: -37.00, category: 'Gas', account_id: 'acc-checking', merchant: 'Shell', type: 'debit' },
    { id: 'feb30', date: '2025-02-20', amount: -43.10, category: 'Gas', account_id: 'acc-checking', merchant: 'Exxon', type: 'debit' },
    { id: 'feb31', date: '2025-02-12', amount: -21.99, category: 'Shopping', account_id: 'liab-cc', merchant: 'Amazon', type: 'debit' },
    { id: 'feb32', date: '2025-02-23', amount: -51.99, category: 'Shopping', account_id: 'liab-cc', merchant: 'Amazon', type: 'debit' },
    { id: 'feb33', date: '2025-02-14', amount: -20.00, category: 'Transfer', account_id: 'acc-checking', merchant: 'Venmo', type: 'debit' },
    { id: 'feb34', date: '2025-02-27', amount: 35.00, category: 'Transfer', account_id: 'acc-checking', merchant: 'Venmo', type: 'credit' },
    // March 2025 (updated, detailed)
    { id: 'mar1', date: '2025-03-03', amount: -1750, category: 'Rent', account_id: 'acc-checking', merchant: 'Austin Apartments', type: 'debit' },
    { id: 'mar2', date: '2025-03-05', amount: -289, category: 'Auto Loan', account_id: 'acc-checking', merchant: 'Capital One Auto', type: 'debit' },
    { id: 'mar3', date: '2025-03-07', amount: -120, category: 'Auto Insurance', account_id: 'acc-checking', merchant: 'USAA', type: 'debit' },
    { id: 'mar4', date: '2025-03-09', amount: -140, category: 'Utilities', account_id: 'acc-checking', merchant: 'Austin Energy', type: 'debit' },
    { id: 'mar5', date: '2025-03-10', amount: -60, category: 'Phone', account_id: 'acc-checking', merchant: 'AT&T', type: 'debit' },
    { id: 'mar6', date: '2025-03-12', amount: -55, category: 'Internet', account_id: 'acc-checking', merchant: 'Spectrum', type: 'debit' },
    { id: 'mar7', date: '2025-03-10', amount: -15.99, category: 'Subscriptions', account_id: 'liab-cc', merchant: 'Netflix', type: 'debit' },
    { id: 'mar8', date: '2025-03-10', amount: -14.99, category: 'Subscriptions', account_id: 'liab-cc', merchant: 'HBO Max', type: 'debit' },
    { id: 'mar9', date: '2025-03-10', amount: -12.99, category: 'Subscriptions', account_id: 'liab-cc', merchant: 'Hulu', type: 'debit' },
    { id: 'mar10', date: '2025-03-10', amount: -7.99, category: 'Subscriptions', account_id: 'liab-cc', merchant: 'Disney+', type: 'debit' },
    { id: 'mar11', date: '2025-03-13', amount: -9.99, category: 'Subscriptions', account_id: 'liab-cc', merchant: 'Spotify', type: 'debit' },
    { id: 'mar12', date: '2025-03-13', amount: -10.00, category: 'Subscriptions', account_id: 'liab-cc', merchant: "Gold's Gym", type: 'debit' },
    { id: 'mar13', date: '2025-03-10', amount: 2607.69, category: 'Salary', account_id: 'acc-checking', merchant: 'NextGen Media Co.', type: 'credit' },
    { id: 'mar14', date: '2025-03-24', amount: 2612.35, category: 'Salary', account_id: 'acc-checking', merchant: 'NextGen Media Co.', type: 'credit' },
    { id: 'mar15', date: '2025-03-25', amount: -600, category: 'Savings', account_id: 'acc-checking', merchant: 'Transfer to Ally', type: 'debit' },
    { id: 'mar16', date: '2025-03-26', amount: -500, category: 'Investments', account_id: 'acc-checking', merchant: 'Transfer to Fidelity', type: 'debit' },
    { id: 'mar17', date: '2025-03-07', amount: -90.30, category: 'Groceries', account_id: 'acc-checking', merchant: 'H-E-B', type: 'debit' },
    { id: 'mar18', date: '2025-03-14', amount: -75.20, category: 'Groceries', account_id: 'acc-checking', merchant: "Trader Joe's", type: 'debit' },
    { id: 'mar19', date: '2025-03-21', amount: -112.50, category: 'Groceries', account_id: 'acc-checking', merchant: 'Whole Foods', type: 'debit' },
    { id: 'mar20', date: '2025-03-28', amount: -63.40, category: 'Groceries', account_id: 'acc-checking', merchant: 'Randalls', type: 'debit' },
    { id: 'mar21', date: '2025-03-04', amount: -15.50, category: 'Dining Out', account_id: 'liab-cc', merchant: 'Starbucks', type: 'debit' },
    { id: 'mar22', date: '2025-03-08', amount: -22.75, category: 'Dining Out', account_id: 'liab-cc', merchant: 'Chipotle', type: 'debit' },
    { id: 'mar23', date: '2025-03-11', amount: -10.25, category: 'Dining Out', account_id: 'liab-cc', merchant: "McDonald's", type: 'debit' },
    { id: 'mar24', date: '2025-03-15', amount: -32.00, category: 'Dining Out', account_id: 'liab-cc', merchant: 'Uchi Sushi', type: 'debit' },
    { id: 'mar25', date: '2025-03-18', amount: -8.00, category: 'Dining Out', account_id: 'liab-cc', merchant: "Dunkin'", type: 'debit' },
    { id: 'mar26', date: '2025-03-22', amount: -24.50, category: 'Dining Out', account_id: 'liab-cc', merchant: "Torchy's Tacos", type: 'debit' },
    { id: 'mar27', date: '2025-03-25', amount: -16.00, category: 'Dining Out', account_id: 'liab-cc', merchant: "P. Terry's", type: 'debit' },
    { id: 'mar28', date: '2025-03-27', amount: -42.90, category: 'Dining Out', account_id: 'liab-cc', merchant: 'Home Slice Pizza', type: 'debit' },
    { id: 'mar29', date: '2025-03-06', amount: -38.00, category: 'Gas', account_id: 'acc-checking', merchant: 'Shell', type: 'debit' },
    { id: 'mar30', date: '2025-03-20', amount: -44.20, category: 'Gas', account_id: 'acc-checking', merchant: 'Exxon', type: 'debit' },
    { id: 'mar31', date: '2025-03-12', amount: -22.99, category: 'Shopping', account_id: 'liab-cc', merchant: 'Amazon', type: 'debit' },
    { id: 'mar32', date: '2025-03-23', amount: -52.99, category: 'Shopping', account_id: 'liab-cc', merchant: 'Amazon', type: 'debit' },
    { id: 'mar33', date: '2025-03-14', amount: -22.00, category: 'Transfer', account_id: 'acc-checking', merchant: 'Venmo', type: 'debit' },
    { id: 'mar34', date: '2025-03-27', amount: 38.00, category: 'Transfer', account_id: 'acc-checking', merchant: 'Venmo', type: 'credit' },
    // April 2025 (updated, detailed)
    { id: 'apr1', date: '2025-04-03', amount: -1750, category: 'Rent', account_id: 'acc-checking', merchant: 'Austin Apartments', type: 'debit' },
    { id: 'apr2', date: '2025-04-05', amount: -289, category: 'Auto Loan', account_id: 'acc-checking', merchant: 'Capital One Auto', type: 'debit' },
    { id: 'apr3', date: '2025-04-07', amount: -120, category: 'Auto Insurance', account_id: 'acc-checking', merchant: 'USAA', type: 'debit' },
    { id: 'apr4', date: '2025-04-09', amount: -140, category: 'Utilities', account_id: 'acc-checking', merchant: 'Austin Energy', type: 'debit' },
    { id: 'apr5', date: '2025-04-10', amount: -60, category: 'Phone', account_id: 'acc-checking', merchant: 'AT&T', type: 'debit' },
    { id: 'apr6', date: '2025-04-12', amount: -55, category: 'Internet', account_id: 'acc-checking', merchant: 'Spectrum', type: 'debit' },
    { id: 'apr7', date: '2025-04-10', amount: -15.99, category: 'Subscriptions', account_id: 'liab-cc', merchant: 'Netflix', type: 'debit' },
    { id: 'apr8', date: '2025-04-10', amount: -14.99, category: 'Subscriptions', account_id: 'liab-cc', merchant: 'HBO Max', type: 'debit' },
    { id: 'apr9', date: '2025-04-10', amount: -12.99, category: 'Subscriptions', account_id: 'liab-cc', merchant: 'Hulu', type: 'debit' },
    { id: 'apr10', date: '2025-04-10', amount: -7.99, category: 'Subscriptions', account_id: 'liab-cc', merchant: 'Disney+', type: 'debit' },
    { id: 'apr11', date: '2025-04-13', amount: -9.99, category: 'Subscriptions', account_id: 'liab-cc', merchant: 'Spotify', type: 'debit' },
    { id: 'apr12', date: '2025-04-13', amount: -10.00, category: 'Subscriptions', account_id: 'liab-cc', merchant: "Gold's Gym", type: 'debit' },
    { id: 'apr13', date: '2025-04-10', amount: 2607.69, category: 'Salary', account_id: 'acc-checking', merchant: 'NextGen Media Co.', type: 'credit' },
    { id: 'apr14', date: '2025-04-24', amount: 2612.35, category: 'Salary', account_id: 'acc-checking', merchant: 'NextGen Media Co.', type: 'credit' },
    { id: 'apr15', date: '2025-04-25', amount: -600, category: 'Savings', account_id: 'acc-checking', merchant: 'Transfer to Ally', type: 'debit' },
    { id: 'apr16', date: '2025-04-26', amount: -500, category: 'Investments', account_id: 'acc-checking', merchant: 'Transfer to Fidelity', type: 'debit' },
    { id: 'apr17', date: '2025-04-07', amount: -92.40, category: 'Groceries', account_id: 'acc-checking', merchant: 'H-E-B', type: 'debit' },
    { id: 'apr18', date: '2025-04-14', amount: -78.30, category: 'Groceries', account_id: 'acc-checking', merchant: "Trader Joe's", type: 'debit' },
    { id: 'apr19', date: '2025-04-21', amount: -115.60, category: 'Groceries', account_id: 'acc-checking', merchant: 'Whole Foods', type: 'debit' },
    { id: 'apr20', date: '2025-04-28', amount: -65.50, category: 'Groceries', account_id: 'acc-checking', merchant: 'Randalls', type: 'debit' },
    { id: 'apr21', date: '2025-04-04', amount: -16.75, category: 'Dining Out', account_id: 'liab-cc', merchant: 'Starbucks', type: 'debit' },
    { id: 'apr22', date: '2025-04-08', amount: -23.00, category: 'Dining Out', account_id: 'liab-cc', merchant: 'Chipotle', type: 'debit' },
    { id: 'apr23', date: '2025-04-11', amount: -11.00, category: 'Dining Out', account_id: 'liab-cc', merchant: "McDonald's", type: 'debit' },
    { id: 'apr24', date: '2025-04-15', amount: -33.00, category: 'Dining Out', account_id: 'liab-cc', merchant: 'Uchi Sushi', type: 'debit' },
    { id: 'apr25', date: '2025-04-18', amount: -8.50, category: 'Dining Out', account_id: 'liab-cc', merchant: "Dunkin'", type: 'debit' },
    { id: 'apr26', date: '2025-04-22', amount: -25.50, category: 'Dining Out', account_id: 'liab-cc', merchant: "Torchy's Tacos", type: 'debit' },
    { id: 'apr27', date: '2025-04-25', amount: -17.00, category: 'Dining Out', account_id: 'liab-cc', merchant: "P. Terry's", type: 'debit' },
    { id: 'apr28', date: '2025-04-27', amount: -43.80, category: 'Dining Out', account_id: 'liab-cc', merchant: 'Home Slice Pizza', type: 'debit' },
    { id: 'apr29', date: '2025-04-06', amount: -39.00, category: 'Gas', account_id: 'acc-checking', merchant: 'Shell', type: 'debit' },
    { id: 'apr30', date: '2025-04-20', amount: -45.30, category: 'Gas', account_id: 'acc-checking', merchant: 'Exxon', type: 'debit' },
    { id: 'apr31', date: '2025-04-12', amount: -23.99, category: 'Shopping', account_id: 'liab-cc', merchant: 'Amazon', type: 'debit' },
    { id: 'apr32', date: '2025-04-23', amount: -53.99, category: 'Shopping', account_id: 'liab-cc', merchant: 'Amazon', type: 'debit' },
    { id: 'apr33', date: '2025-04-14', amount: -24.00, category: 'Transfer', account_id: 'acc-checking', merchant: 'Venmo', type: 'debit' },
    { id: 'apr34', date: '2025-04-27', amount: 40.00, category: 'Transfer', account_id: 'acc-checking', merchant: 'Venmo', type: 'credit' },
    // May 2025 (updated, detailed)
    { id: 'may1', date: '2025-05-03', amount: -1750, category: 'Rent', account_id: 'acc-checking', merchant: 'Austin Apartments', type: 'debit' },
    { id: 'may2', date: '2025-05-05', amount: -289, category: 'Auto Loan', account_id: 'acc-checking', merchant: 'Capital One Auto', type: 'debit' },
    { id: 'may3', date: '2025-05-07', amount: -120, category: 'Auto Insurance', account_id: 'acc-checking', merchant: 'USAA', type: 'debit' },
    { id: 'may4', date: '2025-05-09', amount: -140, category: 'Utilities', account_id: 'acc-checking', merchant: 'Austin Energy', type: 'debit' },
    { id: 'may5', date: '2025-05-10', amount: -60, category: 'Phone', account_id: 'acc-checking', merchant: 'AT&T', type: 'debit' },
    { id: 'may6', date: '2025-05-12', amount: -55, category: 'Internet', account_id: 'acc-checking', merchant: 'Spectrum', type: 'debit' },
    { id: 'may7', date: '2025-05-10', amount: -15.99, category: 'Subscriptions', account_id: 'liab-cc', merchant: 'Netflix', type: 'debit' },
    { id: 'may8', date: '2025-05-10', amount: -14.99, category: 'Subscriptions', account_id: 'liab-cc', merchant: 'HBO Max', type: 'debit' },
    { id: 'may9', date: '2025-05-10', amount: -12.99, category: 'Subscriptions', account_id: 'liab-cc', merchant: 'Hulu', type: 'debit' },
    { id: 'may10', date: '2025-05-10', amount: -7.99, category: 'Subscriptions', account_id: 'liab-cc', merchant: 'Disney+', type: 'debit' },
    { id: 'may11', date: '2025-05-13', amount: -9.99, category: 'Subscriptions', account_id: 'liab-cc', merchant: 'Spotify', type: 'debit' },
    { id: 'may12', date: '2025-05-13', amount: -10.00, category: 'Subscriptions', account_id: 'liab-cc', merchant: "Gold's Gym", type: 'debit' },
    { id: 'may13', date: '2025-05-10', amount: 2607.69, category: 'Salary', account_id: 'acc-checking', merchant: 'NextGen Media Co.', type: 'credit' },
    { id: 'may14', date: '2025-05-24', amount: 2612.35, category: 'Salary', account_id: 'acc-checking', merchant: 'NextGen Media Co.', type: 'credit' },
    { id: 'may15', date: '2025-05-25', amount: -600, category: 'Savings', account_id: 'acc-checking', merchant: 'Transfer to Ally', type: 'debit' },
    { id: 'may16', date: '2025-05-26', amount: -500, category: 'Investments', account_id: 'acc-checking', merchant: 'Transfer to Fidelity', type: 'debit' },
    { id: 'may17', date: '2025-05-07', amount: -93.80, category: 'Groceries', account_id: 'acc-checking', merchant: 'H-E-B', type: 'debit' },
    { id: 'may18', date: '2025-05-14', amount: -76.90, category: 'Groceries', account_id: 'acc-checking', merchant: "Trader Joe's", type: 'debit' },
    { id: 'may19', date: '2025-05-21', amount: -110.20, category: 'Groceries', account_id: 'acc-checking', merchant: 'Whole Foods', type: 'debit' },
    { id: 'may20', date: '2025-05-28', amount: -66.70, category: 'Groceries', account_id: 'acc-checking', merchant: 'Randalls', type: 'debit' },
    { id: 'may21', date: '2025-05-04', amount: -17.25, category: 'Dining Out', account_id: 'liab-cc', merchant: 'Starbucks', type: 'debit' },
    { id: 'may22', date: '2025-05-08', amount: -24.00, category: 'Dining Out', account_id: 'liab-cc', merchant: 'Chipotle', type: 'debit' },
    { id: 'may23', date: '2025-05-11', amount: -12.50, category: 'Dining Out', account_id: 'liab-cc', merchant: "McDonald's", type: 'debit' },
    { id: 'may24', date: '2025-05-15', amount: -34.00, category: 'Dining Out', account_id: 'liab-cc', merchant: 'Uchi Sushi', type: 'debit' },
    { id: 'may25', date: '2025-05-18', amount: -9.00, category: 'Dining Out', account_id: 'liab-cc', merchant: "Dunkin'", type: 'debit' },
    { id: 'may26', date: '2025-05-22', amount: -26.00, category: 'Dining Out', account_id: 'liab-cc', merchant: "Torchy's Tacos", type: 'debit' },
    { id: 'may27', date: '2025-05-25', amount: -18.00, category: 'Dining Out', account_id: 'liab-cc', merchant: "P. Terry's", type: 'debit' },
    { id: 'may28', date: '2025-05-27', date: '2025-05-27', amount: -44.90, category: 'Dining Out', account_id: 'liab-cc', merchant: 'Home Slice Pizza', type: 'debit' },
    { id: 'may29', date: '2025-05-06', amount: -40.00, category: 'Gas', account_id: 'acc-checking', merchant: 'Shell', type: 'debit' },
    { id: 'may30', date: '2025-05-20', amount: -46.10, category: 'Gas', account_id: 'acc-checking', merchant: 'Exxon', type: 'debit' },
    { id: 'may31', date: '2025-05-12', amount: -24.99, category: 'Shopping', account_id: 'liab-cc', merchant: 'Amazon', type: 'debit' },
    { id: 'may32', date: '2025-05-23', amount: -54.99, category: 'Shopping', account_id: 'liab-cc', merchant: 'Amazon', type: 'debit' },
    { id: 'may33', date: '2025-05-14', amount: -25.00, category: 'Transfer', account_id: 'acc-checking', merchant: 'Venmo', type: 'debit' },
    { id: 'may34', date: '2025-05-27', amount: 42.00, category: 'Transfer', account_id: 'acc-checking', merchant: 'Venmo', type: 'credit' },
    // June 2025 (updated, detailed)
    { id: 'jun1', date: '2025-06-03', amount: -1750, category: 'Rent', account_id: 'acc-checking', merchant: 'Austin Apartments', type: 'debit' },
    { id: 'jun2', date: '2025-06-05', amount: -289, category: 'Auto Loan', account_id: 'acc-checking', merchant: 'Capital One Auto', type: 'debit' },
    { id: 'jun3', date: '2025-06-07', amount: -120, category: 'Auto Insurance', account_id: 'acc-checking', merchant: 'USAA', type: 'debit' },
    { id: 'jun4', date: '2025-06-09', amount: -140, category: 'Utilities', account_id: 'acc-checking', merchant: 'Austin Energy', type: 'debit' },
    { id: 'jun5', date: '2025-06-10', amount: -60, category: 'Phone', account_id: 'acc-checking', merchant: 'AT&T', type: 'debit' },
    { id: 'jun6', date: '2025-06-12', amount: -55, category: 'Internet', account_id: 'acc-checking', merchant: 'Spectrum', type: 'debit' },
    { id: 'jun7', date: '2025-06-10', amount: -15.99, category: 'Subscriptions', account_id: 'liab-cc', merchant: 'Netflix', type: 'debit' },
    { id: 'jun8', date: '2025-06-10', amount: -14.99, category: 'Subscriptions', account_id: 'liab-cc', merchant: 'HBO Max', type: 'debit' },
    { id: 'jun9', date: '2025-06-10', amount: -12.99, category: 'Subscriptions', account_id: 'liab-cc', merchant: 'Hulu', type: 'debit' },
    { id: 'jun10', date: '2025-06-10', amount: -7.99, category: 'Subscriptions', account_id: 'liab-cc', merchant: 'Disney+', type: 'debit' },
    { id: 'jun11', date: '2025-06-13', amount: -9.99, category: 'Subscriptions', account_id: 'liab-cc', merchant: 'Spotify', type: 'debit' },
    { id: 'jun12', date: '2025-06-13', amount: -10.00, category: 'Subscriptions', account_id: 'liab-cc', merchant: "Gold's Gym", type: 'debit' },
    { id: 'jun13', date: '2025-06-10', amount: 2607.69, category: 'Salary', account_id: 'acc-checking', merchant: 'NextGen Media Co.', type: 'credit' },
    { id: 'jun14', date: '2025-06-24', amount: 2612.35, category: 'Salary', account_id: 'acc-checking', merchant: 'NextGen Media Co.', type: 'credit' },
    { id: 'jun15', date: '2025-06-25', amount: -600, category: 'Savings', account_id: 'acc-checking', merchant: 'Transfer to Ally', type: 'debit' },
    { id: 'jun16', date: '2025-06-26', amount: -500, category: 'Investments', account_id: 'acc-checking', merchant: 'Transfer to Fidelity', type: 'debit' },
    { id: 'jun17', date: '2025-06-07', amount: -95.10, category: 'Groceries', account_id: 'acc-checking', merchant: 'H-E-B', type: 'debit' },
    { id: 'jun18', date: '2025-06-14', amount: -79.40, category: 'Groceries', account_id: 'acc-checking', merchant: "Trader Joe's", type: 'debit' },
    { id: 'jun19', date: '2025-06-21', amount: -113.80, category: 'Groceries', account_id: 'acc-checking', merchant: 'Whole Foods', type: 'debit' },
    { id: 'jun20', date: '2025-06-28', amount: -68.20, category: 'Groceries', account_id: 'acc-checking', merchant: 'Randalls', type: 'debit' },
    { id: 'jun21', date: '2025-06-04', amount: -18.00, category: 'Dining Out', account_id: 'liab-cc', merchant: 'Starbucks', type: 'debit' },
    { id: 'jun22', date: '2025-06-08', amount: -25.00, category: 'Dining Out', account_id: 'liab-cc', merchant: 'Chipotle', type: 'debit' },
    { id: 'jun23', date: '2025-06-11', amount: -13.00, category: 'Dining Out', account_id: 'liab-cc', merchant: "McDonald's", type: 'debit' },
    { id: 'jun24', date: '2025-06-15', amount: -35.00, category: 'Dining Out', account_id: 'liab-cc', merchant: 'Uchi Sushi', type: 'debit' },
    { id: 'jun25', date: '2025-06-18', amount: -10.00, category: 'Dining Out', account_id: 'liab-cc', merchant: "Dunkin'", type: 'debit' },
    { id: 'jun26', date: '2025-06-22', amount: -27.00, category: 'Dining Out', account_id: 'liab-cc', merchant: "Torchy's Tacos", type: 'debit' },
    { id: 'jun27', date: '2025-06-25', amount: -19.00, category: 'Dining Out', account_id: 'liab-cc', merchant: "P. Terry's", type: 'debit' },
    { id: 'jun28', date: '2025-06-27', amount: -45.90, category: 'Dining Out', account_id: 'liab-cc', merchant: 'Home Slice Pizza', type: 'debit' },
    { id: 'jun29', date: '2025-06-06', amount: -41.00, category: 'Gas', account_id: 'acc-checking', merchant: 'Shell', type: 'debit' },
    { id: 'jun30', date: '2025-06-20', amount: -47.20, category: 'Gas', account_id: 'acc-checking', merchant: 'Exxon', type: 'debit' },
    { id: 'jun31', date: '2025-06-12', amount: -25.99, category: 'Shopping', account_id: 'liab-cc', merchant: 'Amazon', type: 'debit' },
    { id: 'jun32', date: '2025-06-23', amount: -55.99, category: 'Shopping', account_id: 'liab-cc', merchant: 'Amazon', type: 'debit' },
    { id: 'jun33', date: '2025-06-14', amount: -26.00, category: 'Transfer', account_id: 'acc-checking', merchant: 'Venmo', type: 'debit' },
    { id: 'jun34', date: '2025-06-27', amount: 44.00, category: 'Transfer', account_id: 'acc-checking', merchant: 'Venmo', type: 'credit' }
  ]
};

export default mockUser; 